<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="error" @click="open_dialog = true" dark v-on="on">retirer</v-btn>
      </template>

      <v-card v-if="open_dialog">
        <v-card-title class="headline grey lighten-2" primary-title>Retrait Cfa</v-card-title>
        <v-card-text>
          <v-form ref="form" v-if="formulaire">

            <v-text-field solo type="number" label="Montant" v-model="montant" class="input_amount mr-5"
              :rules="nameRules">
            </v-text-field>
            <v-btn color="primary" @click="tout">Max</v-btn>
            <vs-row class="my-3">
              <vs-col vs-justify="center" vs-align="center" w="5">
                MOYEN
              </vs-col>

              <vs-col vs-justify="center" vs-align="center" w="7">

                <vs-select placeholder="MOYEN DE PAIEMENT" v-model="item" style="display:inline-block;">
                  <vs-option-group v-for="moyen in moyens" :key="moyen.country">
                    <div slot="title">
                      {{ moyen.country }}
                    </div>
                    <vs-option class="my-2" v-for="item in moyen.items" :key="item.title" :label="item.title"
                      :value="item.title">
                      <vs-avatar size="20">
                        <img :src="item.img" alt="">
                      </vs-avatar>
                      {{ item.title }}
                    </vs-option>
                  </vs-option-group>
                </vs-select>
              </vs-col>
            </vs-row>
            <v-text-field solo type="number" label="Numero" v-model="numero" :rules="numeroRules"></v-text-field>
            <p class="red--text subheader" v-if="numero.length > 3 && expectedNumberLength !== numero.length">saisissez juste le numero à {{ expectedNumberLength }} chiffres sans indicatif
            </p>

            <v-text-field solo type="number" label="repetez le numero" v-model="repeat_number"></v-text-field>
            <p class="red--text subheader" v-if="!numbers_match">les numero sont differents </p>

            <v-text-field solo label="Nom du compte destinataire" v-model="name" :rules="nameRules"
              v-if="item == 'Ecobank-TOGO'"></v-text-field>
            <v-flex xs12 text-xs-center>
              <v-btn type="submit" color="success" @click.prevent="submit()"
                :disabled='(!numbers_match || !numberValid) ||  montant < 500'>Retirer</v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <p class="red--text subheader" v-if="hmm">solde insuffisant</p>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-dialog v-model="dialog_2fa" max-width="800">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>
            <div style="display:block; text-align:center; margin:auto;">CODE {{
              $store.getters['authfb/user'].auth2fa.google
                ? 'CODE 2FA' : 'PIN' }} </div>
          </v-card-title>
          <v-card-text class="px-3 pt-1 mb-4">
            <div style="display:block; max-width:100%; text-align:center">
              <img src="/img/lock.svg" width="70" alt="">
            </div>
            <p class="caption" style="display:block; max-width:100%; text-align:center">Entrez le code à {{
              $store.getters['authfb/user'].auth2fa.google ? 6 : 4 }} chiffres pour
              confirmer le transfert</p>
            <div class="pl-4" style="text-align:center">
              <input :class="authActivated ? 'code' : 'pin'" v-model="pin2faCode" type="number" maxlength=6
                @input="handleInput" onkeypress="if(this.value.length==6) return false;" />
              <br />
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog_2fa = false">fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import firebase from "../../fb"
export default {
  data() {
    return {
      hmm: false,
      pin2faCode: false,
      expectedNumberLength: 0,
      numberValid:false,
      open_dialog: false,
      dialog_2fa: false,
      formulaire: true,
      yep: false,
      montant: "",
      code: "",
      fee: "",
      pass: process.env.VUE_APP_SECRET,
      numero: "",
      repeat_number: "",
      name: "",
      item: "",
      dialog: false,
      totp_validate: process.env.VUE_APP_TOTP_VALIDATE,

      nameRules: [v => !!v || "obligatoire"],
      numeroRules: [v => !!v || "obligatoire",
      ]
    };
  },
  computed: {
    authActivated() {
      return this.$store.getters['authfb/user'].auth2fa.google
    },
    numbers_match() {
      return this.numero == this.repeat_number && this.repeat_number.toString().length >= 8
    },
    moyens() {
      let moyens = []
      return this.instant_data.hiropay.moyens.map(el => {
        let country = el.country
        country == 'civ' ? el.country = "Cote d'ivoire" : ''
        let items = el.items
        el.items = items.filter(item => item.active == true)
        //el.items.length > 0 ? moyens.push(el) : ''
        return el
      })
    },

    instant_data() {
      let obj = {}
      this.instant.forEach(element => {
        obj[`${element.id}`] = element
      });
      return obj
    },

    ...mapGetters({
      instant: "authfb/instant"
    }),

    ...mapGetters({
      cfa: "authfb/cfa",
      user: "authfb/user"
    })

  },
  watch: {
    pin2faCode(newValue, oldValue) {
      let codeLength = this.authActivated ? 6 : 4
      let code = newValue.slice(0, codeLength)
      console.log(code, codeLength);
      if (newValue.length == codeLength) {
        this.validate();
      }
    },

    montant(newValue, oldValue) {
      this.debouncedFee()
    },
    numero(newValue, oldValue) {
      let moyen = this.item
      if (moyen.length < 2 ) {
        console.log('moyen invid');
        alert('veuillez choisir un moyen de paiement')
        return
      }
      console.log('moyen', moyen);
      let payload = {moyen , number : this.numero}
      let {expectedNumberLength, numberValid} = this.validPhoneNumber(payload)
      console.log(numberValid);
      this.expectedNumberLength = expectedNumberLength
      this.numberValid = numberValid
    },
  },

  
  created: function () {
    this.debouncedFee = _.debounce(this.setFee, 200);
  },
  mounted() {
    this.bind_perso();
    this.bind_instant()
  },

  methods: {

    handleInput() {
      let codeLength = this.authActivated ? 6 : 4;
      if (this.pin2faCode.length > codeLength) {
        this.pin2faCode = this.pin2faCode.slice(0, this.codeLength); // 
      }
    },
    tout() {
      var cfa = Number(this.$store.getters["authfb/cfa"])
      this.montant = Math.floor(cfa)
      console.log(this.montant);
    },

   setFee() {
  const ranges = [
    { min: 5000,    max: 20000,    fee: 200 },
    { min: 20000,   max: 50000,    fee: 500 },
    { min: 50000,   max: 100000,   fee: 700 },
    { min: 100000,  max: 200000,   fee: 1500 },
    { min: 200000,  max: 300000,   fee: 2000 },
    { min: 300000,  max: 400000,   fee: 3000 },
    { min: 400000,  max: 500000,   fee: 4000 },
    { min: 500000,  max: 750000,   fee: 6000 },
    { min: 750000,  max: 1000000,  fee: 7500 },
    { min: 1000000, max: 1500000,  fee: 10000 },
    { min: 1500000, max: Infinity, fee: 15000 },
  ];

  this.fee = 200; // valeur par défaut
  for (const range of ranges) {
    if (this.montant >= range.min && this.montant < range.max) {
      this.fee = range.fee;
      break;
    }
  }

  console.log(this.fee, 'fee calculated');
},

   async dispatch_withdraw() {
  console.log('fee ', this.fee);

  const user = firebase.auth().currentUser;
  const store = this.$store.getters;

  const paygate_withdraw_count = store["authfb/perso"].paygate_withdraw_count;
  const flooz_limit = store["authfb/perso"].flooz_daily_limit_amount;
  const user_data = store["authfb/user"];
  const daily_flooz_withdraw_count = user_data.flooz_withdraw_count || 0;
  const { user_id, last_deposit } = user_data;

  console.log(user_id, last_deposit);
  if (typeof last_deposit === 'undefined') {
    console.log('not exist');
  }

  const montant = Number(this.montant);

  // Définir les frais en fonction du pays/moyen
  const threshold = 50000;
  const defaultFee = 500;
  const percentFee = 0.01 * montant;

  const method = this.item;
  const numeroStr = this.numero.toString();

  const civ_methods = ['ORANGE-CIV', `MTN COTE D'IVOIRE`, 'MOOV-CIV'];
  const sen_methods = ['ORANGE-SENEGAL'];
  const other_methods = ['ORANGE BURKINA', 'MALITEL', 'AIRTEL NIGER', 'Mtn Benin'];

  // Appliquer les règles spécifiques selon le moyen de retrait
  if (other_methods.includes(method)) {
    this.fee = montant > threshold ? percentFee : defaultFee;
  }

  if (civ_methods.includes(method)) {
    this.fee = montant > threshold ? percentFee : defaultFee;

    if (montant >= 500000) {
      swal("Erreur", "Saisissez un montant inférieur à 500 000 FCFA", "error", { button: "OK" });
      return;
    }

    if (numeroStr.length !== 10) {
      swal("Erreur", "Saisir un numéro à 10 chiffres", "error", { button: "OK" });
      return;
    }
  }

  if (sen_methods.includes(method)) {
    this.fee = montant > threshold ? percentFee : defaultFee;

    if (montant >= 500000) {
      swal("Erreur", "Saisissez un montant inférieur à 500 000 FCFA", "error", { button: "OK" });
      return;
    }

    if (numeroStr.length !== 9) {
      swal("Erreur", "Saisir un numéro à 9 chiffres", "error", { button: "OK" });
      return;
    }
  }

  // Cas spéciaux : frais à 0 pour certains utilisateurs
  const freeFeeUsers = [
    'GdpDkMaABtPYy2NUdfq5ahT2IUt1',
    'PyrcmKkU5fN9BF8QahW9Okmolq22',
   // TONY
  ];

  if (freeFeeUsers.includes(user.uid)) {
    this.fee = 0;
  }

  const auth_token = await this.firebase_auth_token();

  console.log(this.fee, 'final fee');

  const dispatchPayload = {
    montant,
    moyen: method,
    numero: this.numero,
    name: this.name,
    fee: this.fee,
    auth_token,
    base_url: this.base_url,
    flooz_withdraw_count: daily_flooz_withdraw_count,
    flooz_limit,
    paygate_withdraw_count,
    main_api: this.main_api,
    token: this.pin2faCode,
    vm: this
  };

  console.log('dispatch payload', dispatchPayload);

  this.$store.dispatch("withdraw/retraitCfa", dispatchPayload).then(() => {
    console.log(this.fee);
    this.$vs.loading().close();
    this.dialog_2fa = false;
    this.code = '';
    this.formulaire = false;
    this.yep = true;
    this.$refs.form.reset();
    this.numero = '';
    this.repeat_number = '';

    setTimeout(() => {
      this.formulaire = true;
      this.yep = false;
    }, 5000);
  });
},

submit() {
  const minimum = 2000;

  // Vérifie que le moyen de paiement est sélectionné
  if (!this.item || this.item.length < 3) {
    swal("Erreur", "Veuillez sélectionner un moyen de paiement", "error", {
      button: "OK"
    });
    return;
  }

  // Vérifie que le montant est supérieur ou égal au minimum requis
  if (this.montant < minimum) {
    swal(`Montant minimum ${minimum} FCFA`, "Veuillez changer le montant", "error", {
      button: "OK"
    });
    return;
  }

  // Vérifie que le formulaire est valide
  const isValid = this.$refs.form.validate();
  console.log(isValid, 'form valid');
  
  if (!isValid) return;

  // Vérifie que le solde est suffisant
  if (this.montant > this.cfa) {
    this.hmm = true;
    setTimeout(() => {
      this.hmm = false;
    }, 2000);
    return;
  }

  // Si tout est bon, on ouvre le dialogue d'authentification 2FA
  this.dialog = false;
  this.dialog_2fa = true;
}
,
async validate() {
  try {
    const isValid = await this.valid_auth_pin(this.pin2faCode);
    console.log('PIN valid:', isValid);

    if (isValid) {
      this.dispatch_withdraw();

      this.$vs.notification({
        color: 'success',
        position: 'top-right',
        title: 'Succès',
        text: 'Code correct, retrait en cours'
      });
    } else {
      swal("Code invalide !", "Veuillez réessayer", "error", {
        button: "OK"
      });
      this.code = '';
    }
  } catch (error) {
    console.error('Erreur lors de la validation du code PIN:', error);
    swal("Erreur", "Une erreur est survenue, veuillez réessayer", "error", {
      button: "OK"
    });
  }
},

    ...mapActions("authfb", ["bind_perso"]),
    ...mapActions('authfb', ['bind_instant']),
  }
};
</script>

<style lang="scss">
$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 6;
$in-w: $n-char * ($char-w + $gap);

input.code {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(90deg,
    dimgrey 0,
    dimgrey $char-w,
    transparent 0,
    transparent $char-w + $gap ) 0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}


$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 4;
$in-w: $n-char * ($char-w + $gap);

input.pin {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(90deg,
    dimgrey 0,
    dimgrey $char-w,
    transparent 0,
    transparent $char-w + $gap ) 0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}


.input_amount {
  max-width: 220px !important;
  display: inline-block;
  margin: auto;
}

div.v-input.input_amount {
  font-size: 2em !important;
  align-content: center;
}
</style>
